import { FC } from 'react';
import { MilieugegevensFlow } from '../milieugegevens-flow';
import { MetingenV2 } from '../v2/metingen-v2';
import { ZuiveringswijzeV2 } from '../v2/zuiveringswijze-v2';
import { LozingsvormV3 } from '../v3/lozingsvorm-v3';
import { LozingenV4 } from './lozingen-v4';

export const GrondteeltMilieugegevensV4: FC = () => (
  <MilieugegevensFlow
    teeltwijze={0}
    renderZuiveringswijze={() => <ZuiveringswijzeV2 teeltwijze={0} />}
    LozingsvormComponent={LozingsvormV3}
    LozingenComponent={LozingenV4}
    MetingenComponent={MetingenV2}
    showFosforStikstof
    alwaysShowLozingen
  />
);
